import React from 'react';
import { Checkbox, Form, Radio } from 'semantic-ui-react';

const CompetitionForm = (props) => {
  
  const {
    robotRequired,
    difficulty,
    teamMemberLimit,
    competitionType,
    attemptsLimit,
    attemptMaxLengthInSeconds,
    concurrentCompetitors,
    rrtCompetitorsInGroupMin,
    rrtCompetitorsInGroupMax,
    rrtCompetitorsInGroupAdvancing,
    rrtConcurrentGroups,
    rrtConcurrentGroupGames
  } = props.data;
  const { onChange, onToggle } = props;

  return (
    <div>
      <Form.Group widths='equal'>
        <Form.Field>
          <b>Difficulty:</b>
        </Form.Field>
        <Form.Field>
          <Radio
            name='difficulty'
            label='Beginner'
            value='beginner'
            checked={difficulty === 'beginner'}
            onChange={onChange}
          />
        </Form.Field>
        <Form.Field>
          <Radio
            name='difficulty'
            label='Intermediate'
            value='intermediate'
            checked={difficulty === 'intermediate'}
            onChange={onChange}
          />
        </Form.Field>
        <Form.Field>
          <Radio
            name='difficulty'
            label='Advanced'
            value='advanced'
            checked={difficulty === 'advanced'}
            onChange={onChange}
          />
        </Form.Field>
      </Form.Group>
      <Form.Field
        control={Checkbox}
        label='Robot name is required when registering for the competition'
        name='robotRequired'
        checked={robotRequired}
        onChange={onToggle} />
      <Form.Input
        required
        label='Max member count (set to 0 for no limit)'
        placeholder=''
        name='teamMemberLimit'
        value={teamMemberLimit}
        onChange={onChange} />
      
      <Form.Group>
        <Form.Field width={4}>
          <b>Competition type:</b>
        </Form.Field>
        <Form.Field width={4}>
          <Radio
            name='competitionType'
            label='Time Table'
            value='TIME'
            checked={competitionType === 'TIME'}
            onChange={onChange}
          />
        </Form.Field>
        <Form.Field width={4}>
          <Radio
            name='competitionType'
            label='Points Table'
            value='POINTS'
            checked={competitionType === 'POINTS'}
            onChange={onChange}
          />
        </Form.Field>
      </Form.Group>
      
      <Form.Group>
        <Form.Field width={4}/>
        <Form.Field width={4}>
          <Radio
            name='competitionType'
            label='Points table (summed)'
            value='POINTS_SUMMED'
            checked={competitionType === 'POINTS_SUMMED'}
            onChange={onChange}
          />

        </Form.Field>
        <Form.Field width={8}>
          <Radio
            name='competitionType'
            label='Folkrace'
            value='FOLKRACE'
            checked={competitionType === 'FOLKRACE'}
            onChange={onChange}
          />
        </Form.Field>
      </Form.Group>
      
      <Form.Group>
        <Form.Field width={4}/>
        <Form.Field width={4}>
          <Radio
            name='competitionType'
            label='External'
            value='EXTERNAL'
            checked={competitionType === 'EXTERNAL'}
            onChange={onChange}
          />

        </Form.Field>
        <Form.Field width={8}>
          <Radio
            name='competitionType'
            label='Round-Robin Tournament + Double Elimination'
            value='RRT_DE'
            checked={competitionType === 'RRT_DE'}
            onChange={onChange}
          />
        </Form.Field>
      </Form.Group>

      

      
      <Form.Group>
        <Form.Field width={4}>
          <b>Attempts:</b>
        </Form.Field>
        <Form.Input
          width={4}
          label='Number of attemps'
          name='attemptsLimit'
          value={attemptsLimit}
          onChange={onChange} />
        <Form.Input
          width={4}
          label='Max. attempt length (s)'
          name='attemptMaxLengthInSeconds'
          value={attemptMaxLengthInSeconds}
          onChange={onChange} />
      </Form.Group>
      
      <Form.Group>
        <Form.Field width={4}>
          <b>Other:</b>
        </Form.Field>
        <Form.Input
          width={4}
          label='Concurrent competitors'
          name='concurrentCompetitors'
          value={concurrentCompetitors}
          onChange={onChange} />
      </Form.Group>

      <Form.Group>
        <Form.Field width={8}>
          <b>Round-Robin and Folkrace Tournament specific:</b>
        </Form.Field>
      </Form.Group>

      <Form.Group>
        <Form.Field width={4}>
          <b>Competitors in Group:</b>
        </Form.Field>
        <Form.Input
          width={4}
          label='Minimum group size (RR/FR)'
          name='rrtCompetitorsInGroupMin'
          value={rrtCompetitorsInGroupMin}
          onChange={onChange} />
        <Form.Input
          width={4}
          label='Maximum group size (RR/FR)'
          name='rrtCompetitorsInGroupMax'
          value={rrtCompetitorsInGroupMax}
          onChange={onChange} />
        <Form.Input
          width={4}
          label='Advancing robots (RR/FR)'
          name='rrtCompetitorsInGroupAdvancing'
          value={rrtCompetitorsInGroupAdvancing}
          onChange={onChange} />
      </Form.Group>
      
      <Form.Group>
        <Form.Field width={4}>
          <b>Group:</b>
        </Form.Field>
        <Form.Input
          width={4}
          label='Concurrent Groups'
          name='rrtConcurrentGroups'
          value={rrtConcurrentGroups}
          onChange={onChange} />
        <Form.Input
          width={4}
          label='Concurrent games in group'
          name='rrtConcurrentGroupGames'
          value={rrtConcurrentGroupGames}
          onChange={onChange} />
      </Form.Group>
    </div>
  );
};

export default CompetitionForm;



// WEBPACK FOOTER //
// ./src/private/admin/components/Competition/Panes/Competition.js